import {
  makeStyles, Theme, Grid, TableContainer,
  Table, TableHead, TableRow, TableBody, TableCell, Checkbox, Box
} from "@material-ui/core";
import { DocReviewBaseStore } from '../store/docReviewBaseStore';
import { observer } from "mobx-react";
import { useEffect } from "react";
import { AIDocType } from "@roc/feature-documents";

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    padding: '20px 20px 0 20px'
  },
  reviewSectionContainer: {
    paddingBottom: '20px'
  },
  tableContainer: {
    border: '1px #e0e0e0 solid',
    backgroundColor: '#FFF',
    width: '100%',
    boxSizing: 'border-box',
  },
  table: {
    margin: 0,
    padding: 0,
    '& td': {
      padding: '5px 0',
    },
    '& th:first-child, td[rowSpan], $addNewItemRow td, td:first-child': {
      padding: theme.spacing(2),
      paddingRight: '3px',
    },
    '& table tr:last-child td, & table td[rowSpan]': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '12px',
      fontSize: '0.875rem'
    }
  },
  checkBoxCell: {
    width: '8%',
  },
  uplodCell: {
    width: '11%',
  },
  docCell: {
    width: '81%'
  },
  cell: {
    padding: '12px !important',
    paddingRight: '24px !important',
  },
  header: {
    fontWeight: 'bold',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const DocumentChecklist = observer(({ store, loanId, docType, readOnly }
  : { store: DocReviewBaseStore, loanId: number, docType: AIDocType, readOnly: boolean }) => {
  const classes = useStyles();

  useEffect(() => {
    store.getDocChecklist(loanId, docType)
  }, [])


  return (
    <Grid container className={classes.reviewSectionContainer}>
      <Grid container item xs={12} style={{ maxHeight: '55vh', overflow: 'auto' }}>
        <Grid item xs={12} className={classes.section}>
          <TableContainer className={classes.tableContainer}>
            <Table className={classes.table} size='small' stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={`${classes.header} ${classes.cell} ${classes.center}`}>
                    <Checkbox checked={store.fullChecklistStatus} disabled={readOnly}
                      onChange={(e, checked) => { store.onChangeFullChecklist(checked) }} /></TableCell>
                  <TableCell className={`${classes.header} ${classes.cell}`}>Document</TableCell>
                  <TableCell className={`${classes.header} ${classes.cell}`}>Uploaded Date</TableCell>
                </TableRow>
              </TableHead>
              {store.docChecklist.map(doc => (
                <>
                  <TableBody key={`${doc.name}-body-rows`}>
                    <TableRow key={`${doc.name}-content-row`}>
                      <TableCell className={`${classes.checkBoxCell} ${classes.cell}`}>
                        <Box className={classes.center}>
                          <Checkbox checked={doc.checked} disabled={readOnly}
                            onChange={(e, checked) => store.onChangeDocListItem(doc.name, 'checked', checked)} />
                        </Box></TableCell>
                      <TableCell key={doc.name}
                        className={`${classes.docCell} ${classes.cell}`}>{doc.name}</TableCell>
                      <TableCell key={doc.name}
                        className={`${classes.uplodCell} ${classes.cell}`}>{doc.lastUploadedDate}</TableCell>
                    </TableRow>
                  </TableBody>
                </>
              ))}
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Grid>);
});